"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _CustomValue = _interopRequireDefault(require("./Filters/CustomValue"));

var _DateRange = _interopRequireDefault(require("./Filters/DateRange"));

var _NumericRange = _interopRequireDefault(require("./Filters/NumericRange"));

var _Value = _interopRequireDefault(require("./Filters/Value"));

require("./style.scss");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var SearchSelectedFilters = function SearchSelectedFilters(_ref) {
  var _results$summary;

  var data = _ref.data,
      loading = _ref.loading;

  if (!data) {
    return null;
  }

  var results = data.results; // All filter components are copies of Searchkit's own filters, recreated within our library.
  // Only the CustomValueFilter is a completely custom filter, written by us. Hence the name.

  var filterComponentMap = {
    ListFacet: _CustomValue.default,
    RangeSliderFacet: _NumericRange.default,
    DateRangeFacet: _DateRange.default,
    ComboBoxFacet: _Value.default,
    HierarchicalMenuFacet: _Value.default,
    SelectFacet: _CustomValue.default,
    ChipFacet: _CustomValue.default,
    HierarchicalFilterFacet: _CustomValue.default
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "SearchSelectedFilters"
  }, results === null || results === void 0 ? void 0 : (_results$summary = results.summary) === null || _results$summary === void 0 ? void 0 : _results$summary.appliedFilters.map(function (filter) {
    var FilterComponent = filterComponentMap[filter.display] || _Value.default;

    if (!filterComponentMap[filter.display]) {
      throw new Error("could not display selected filters for ".concat(filter.identifier, " facet. Use customFilterComponents prop to pass a component to handle this filter for ").concat(filter.display, " display"));
    }

    return /*#__PURE__*/_react.default.createElement(FilterComponent, {
      filter: filter,
      loading: loading,
      key: filter.id
    });
  }));
};

var _default = SearchSelectedFilters;
exports.default = _default;